import React from "react";
import style from "../../Styles/Components/CheckList.module.css";

const getCheckImage = (checked) => (
    checked ? <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-checked.svg"} className={style.check}></img> : 
    <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-check.svg"} className={style.check}></img>
)

const CheckItem = ({ onClick= ()=>{}, content, isChecked, title, bottomContents = null, id, customStyle={} }) => (
    <>
    <li id={id} onClick={()=>onClick(id)} className={[style.list_item, bottomContents ? null : style.bottom_border ].join(' ')} style={customStyle}>
        {getCheckImage(isChecked)}
        <span className={style.list_font}>{title}</span>
    </li>
    {bottomContents && 
        <li id={`bottom_${id}`} className={style.list_item} style={{paddingRight: '20px'}}>
            {bottomContents}
        </li>}
    </>
);

export default CheckItem;